export const SET_ADDRESS_DATA='SET_ADDRESS_DATA'

export const UPDETE_ADDRESS = 'UPDETE_ADDRESS'
export const DELETE_ADDRESS='DELETE_ADDRESS'
export const RECORD_ADDRESS = 'RECORD_ADDRESS'
export const ADD_CART = 'ADD_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const EDIT_CART = 'EDIT_CART'
export const SELECT_CART = 'SELECT_CART'
export const SET_CART_TOTAL = 'SET_CART_TOTAL'
export const INIT_BUYCART = 'INIT_BUYCART'
export const INIT_REPLACE_BUYCART='INIT_REPLACE_BUYCART'
export const CLEAR_CART = 'CLEAR_CART'
export const SET_NOTICES = 'SET_NOTICES'
export const SET_WAREHOUSE = 'SET_WAREHOUSE'
export const SET_PRODUCT = 'SET_PRODUCT'
export const SET_PRODUCTSTOCK = 'SET_PRODUCTSTOCK'
export const RECORD_SHOPDETAIL = 'RECORD_SHOPDETAIL'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const GET_USERINFO = 'GET_USERINFO'
export const CONFIRM_REMARK = 'CONFIRM_REMARK'
export const CONFIRM_INVOICE = 'CONFIRM_INVOICE'
export const CHOOSE_SEARCH_ADDRESS = 'CHOOSE_SEARCH_ADDRESS'
export const SAVE_GEOHASH = 'SAVE_GEOHASH'
export const CONFIRM_ADDRESS = 'CONFIRM_ADDRESS'
export const CHOOSE_ADDRESS = 'CHOOSE_ADDRESS'
export const NEED_VALIDATION = 'NEED_VALIDATION'
export const SAVE_CART_ID_SIG = 'SAVE_CART_ID_SIG'
export const SAVE_ORDER_PARAM = 'SAVE_ORDER_PARAM'
export const CHANGE_ORDER_PARAM = 'CHANGE_ORDER_PARAM'
export const ORDER_SUCCESS = 'ORDER_SUCCESS'
export const SAVE_SHOPID = 'SAVE_SHOPID'
export const SAVE_ORDER = 'SAVE_ORDER'
export const OUT_LOGIN = 'OUT_LOGIN'
export const RETSET_NAME = 'RETSET_NAME'
export const SAVE_AVANDER = 'SAVE_AVANDER'
export const SAVE_ADDDETAIL = 'SAVE_ADDDETAIL'
export const SAVE_ADDRESS = 'SAVE_ADDRESS'
export const SAVE_QUESTION = 'SAVE_QUESTION'
export const ADD_ADDRESS = 'ADD_ADDRESS'
export const BUY_CART = 'BUY_CART'
export const EDIT_USERINFO='EDIT_USERINFO'
export const SET_CONTRACT='SET_CONTRACT'
export const SAVE_EXTEND='SAVE_EXTEND'
export const SAVE_LRPR='SAVE_LRPR'
export const SAVE_PAYRECORD='SAVE_PAYRECORD'
export const SET_ORDERNN='SET_ORDERNN'
export const PAY_STATE='PAY_STATE'
export const EDIT_USERINFO_IDCAR='EDIT_USERINFO_IDCAR'
export const EDIT_USERINFO_QRCODE='EDIT_USERINFO_QRCODE'
export const SET_PROMTE='SET_PROMTE'
export const SET_FORCUSTOMER='SET_FORCUSTOMER'
export const CLEAR_DATA='CLEAR_DATA';
export const SET_NEWPROMOCODE='SET_NEWPROMOCODE';
export const SET_NEWPROMOCODEALL='SET_NEWPROMOCODEALL'
export const REDUCE_NEWPROMOCODE='REDUCE_NEWPROMOCODE';
export const INIT_NEWPROMOCODE='INIT_NEWPROMOCODE';
export const SET_CHARITABLE='SET_CHARITABLE';
export const REDUCEALL_CART='REDUCEALL_CART';
export const SET_ORDERTYPE='SET_ORDERTYPE'
export const SET_CART_TOTALRPT='SET_CART_TOTALRPT'
export const RECORDWX_USERINFO='RECORDWX_USERINFO'
export const EDIT_CART1='EDIT_CART1'
export const SET_ORDERSTATUS='SET_ORDERSTATUS';
export const SET_ORIGINA='SET_ORIGINA';
export const REDUCEALL_ORDERINFO='REDUCEALL_ORDERINFO';
export const SET_BIRTHDAYLIMT='SET_BIRTHDAYLIMT';
export const SET_PRODUCTLIMT='SET_PRODUCTLIMT';
export const SET_PAYLOAD='SET_PAYLOAD';
export const REDUCE_PAYLOAD='REDUCE_PAYLOAD'
export const REDUCEALL_LRP='REDUCEALL_LRP'
export const SET_SELECTMERGE='SET_SELECTMERGE'
export const SET_CARTCHECK='SET_CARTCHECK'
export const SET_BALANCERECORD='SET_BALANCERECORD'
export const LOAD_CARTCHECK='LOAD_CARTCHECK'
export const REDUCEALL_SELCART='REDUCEALL_SELCART'
export const SET_CARTCHECKALL='SET_CARTCHECKALL'
export const TRIGGER_MERGE = 'TRIGGER_MERGE'
export const SET_PTBALANCE = 'SET_PTBALANCE'

export const SET_COMBINEPROMOTEPRODUCT = 'SET_COMBINEPROMOTEPRODUCT'

export const SET_PRODUCTMENUTREE = 'SET_PRODUCTMENUTREE'




